import { Card } from "@/components/ui/card";
import { user as userApi } from "@/endpoints/dryp/user";
import { useStore } from "@/hooks/useStore";
import { UserStorage } from "@/storage/UserStorage";
import { Loader2 } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useState } from "react";
import { AppLink } from "@/components/AppLink";
import { Button } from "@/components/ui/button";

export const SSO = observer(() => {
	const store = useStore();
	const { userStore } = store;
	const callbackParams = useMemo(() => new URLSearchParams(window.location.hash.slice(1)), []);
	const userToken = callbackParams.get("token");
	const email = callbackParams.get("email");
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		window.history.replaceState(null, "", window.location.pathname);

		const fetchData = async () => {
			if (userToken) {
				UserStorage.setToken(userToken);
				const jwtUser = UserStorage.getUser();

				if (jwtUser) {
					try {
						const { organizations } = await userApi.getAuthUser();
						const activeOrg = organizations.find(o => o.organizationId === jwtUser.organizationId);

						userStore.setUserAndOrganization(
							{ name: jwtUser.name, roles: jwtUser.roles },
							{ Id: jwtUser.organizationId, Name: activeOrg?.organizationName, Description: "" },
							organizations,
						);
						userStore.setLoggedIn();
					} catch (error) {
						console.error(error);
						setIsError(true);
						UserStorage.removeToken();
					}
				} else {
					setIsError(true);
					UserStorage.removeToken();
				}
			} else {
				setIsError(true);
			}
		};

		fetchData();
	}, [userToken, email, userStore]);

	if (isError) {
		return (
			<Card className="flex flex-col justify-center items-center min-h-40 text-primary gap-4 p-6">
				<p>
					Single Sign-On (SSO) authentication was unsuccessful. Please try again or contact support if the
					issue persists.
				</p>
				<Button asChild>
					<AppLink to="Auth.Login" params={{}}>
						Back to login
					</AppLink>
				</Button>
			</Card>
		);
	}

	return (
		<Card className="flex justify-center items-center min-h-40 text-primary">
			<Loader2 className="animate-spin h-20 w-20" />
		</Card>
	);
});
